/**
 * Unified mobile drawer: menu (#offcanvas), cart (#dropdown-cart),
 * filters (#filter-sidebar), home nav (#dw-home-sidebar).
 * Exposes window.DwMobileDrawer for dw-product.js and other callers.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 991;
  var activeId = null;
  var lastTrigger = null;

  var panels = {
    menu: {
      selector: '#offcanvas',
      mobileOnly: false,
      onOpen: function () {
        if (typeof window.showOffcanvasTab === 'function') {
          window.showOffcanvasTab('Shop');
        }
      }
    },
    cart: {
      selector: '#dropdown-cart',
      mobileOnly: false
    },
    filters: {
      selector: '#filter-sidebar',
      mobileOnly: true
    },
    'home-nav': {
      selector: '#dw-home-sidebar',
      mobileOnly: true,
      mobileMax: 1024
    }
  };

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function panelMobileMax(id) {
    var config = panels[id];
    return (config && config.mobileMax) || MOBILE_MAX;
  }

  function getPanelEl(id) {
    var config = panels[id];
    return config ? document.querySelector(config.selector) : null;
  }

  function canOpen(id) {
    var el = getPanelEl(id);
    if (!el) return false;
    if (panels[id].mobileOnly && window.innerWidth > panelMobileMax(id)) return false;
    return true;
  }

  function setTriggersExpanded(id, expanded) {
    var val = expanded ? 'true' : 'false';
    document.querySelectorAll('[data-dw-drawer-open="' + id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', val);
    });
    if (id === 'menu') {
      document.querySelectorAll('.btn-menu-canvas').forEach(function (btn) {
        btn.setAttribute('aria-expanded', val);
      });
    }
    if (id === 'cart') {
      document.querySelectorAll('.dw-header-cart-toggle, .cartToggle').forEach(function (btn) {
        btn.setAttribute('aria-expanded', val);
      });
    }
    if (id === 'filters' || id === 'home-nav') {
      document.querySelectorAll('.filter-collection-left > a').forEach(function (btn) {
        btn.setAttribute('aria-expanded', val);
      });
    }
  }

  function getOverlay() {
    return document.querySelector('.dw-drawer-overlay');
  }

  function clearLegacyState() {
    var body = document.body;
    var wrapper = document.querySelector('.wrapper-container');
    body.classList.remove('off-canvas-active');
    body.removeAttribute('data-dw-drawer-active');
    body.style.overflow = '';
    if (wrapper) {
      wrapper.classList.remove('show-cart', 'show-fillter', 'offcanvas-push');
    }
    document.querySelectorAll('.toolbar.active').forEach(function (t) {
      t.classList.remove('active');
    });
  }

  function applyLegacyOpenState(id, el) {
    var body = document.body;
    var wrapper = document.querySelector('.wrapper-container');
    if (id === 'menu') {
      body.classList.add('off-canvas-active');
      el.classList.add('active');
      if (wrapper) wrapper.classList.add('offcanvas-push');
    } else if (id === 'cart') {
      el.classList.add('active');
      if (wrapper) wrapper.classList.add('show-cart');
    } else if (id === 'filters' || id === 'home-nav') {
      el.classList.add('active');
      if (wrapper) wrapper.classList.add('show-fillter');
      document.querySelectorAll('.dw-home-toolbar, .dw-collection-toolbar').forEach(function (t) {
        t.classList.add('active');
      });
    }
  }

  function closeAll() {
    Object.keys(panels).forEach(function (id) {
      var el = getPanelEl(id);
      if (el) {
        el.classList.remove('is-open', 'active');
        el.setAttribute('aria-hidden', 'true');
      }
      setTriggersExpanded(id, false);
    });
    document.body.classList.remove('dw-drawer-open');
    clearLegacyState();
    activeId = null;
    var ov = getOverlay();
    if (ov) {
      ov.classList.remove('is-visible');
      ov.setAttribute('aria-hidden', 'true');
    }
    var homeNav = getPanelEl('home-nav');
    if (homeNav && window.innerWidth > panelMobileMax('home-nav')) {
      homeNav.setAttribute('aria-hidden', 'false');
    }
  }

  function open(id, trigger) {
    if (!canOpen(id)) return;
    if (activeId === id) {
      var prev = lastTrigger;
      closeAll();
      if (prev) {
        try { prev.focus(); } catch (e) {}
      }
      return;
    }
    closeAll();
    var config = panels[id];
    var el = getPanelEl(id);
    if (!el) return;

    activeId = id;
    lastTrigger = trigger || null;

    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (config.onOpen) config.onOpen();

    var body = document.body;
    body.classList.add('dw-drawer-open');
    body.setAttribute('data-dw-drawer-active', id);
    body.style.overflow = 'hidden';

    applyLegacyOpenState(id, el);

    var ov = getOverlay();
    if (ov) {
      ov.classList.add('is-visible');
      ov.setAttribute('aria-hidden', 'false');
    }

    setTriggersExpanded(id, true);
  }

  function close() {
    var trigger = lastTrigger;
    closeAll();
    if (trigger) {
      try { trigger.focus(); } catch (e) {}
    }
    lastTrigger = null;
  }

  function initMarkup() {
    var menu = document.getElementById('offcanvas');
    if (menu) {
      menu.classList.add('dw-mobile-drawer', 'dw-mobile-drawer--left');
      menu.setAttribute('data-dw-drawer-panel', 'menu');
      menu.setAttribute('aria-hidden', 'true');
    }
    var cart = document.getElementById('dropdown-cart');
    if (cart) {
      cart.classList.add('dw-mobile-drawer', 'dw-mobile-drawer--right');
      cart.setAttribute('data-dw-drawer-panel', 'cart');
      cart.setAttribute('aria-hidden', 'true');
    }
    var filters = document.getElementById('filter-sidebar');
    if (filters) {
      filters.classList.add('dw-mobile-drawer', 'dw-mobile-drawer--left');
      filters.setAttribute('data-dw-drawer-panel', 'filters');
      filters.setAttribute('aria-hidden', 'true');
    }
    var homeNav = document.getElementById('dw-home-sidebar');
    if (homeNav) {
      homeNav.classList.add('dw-mobile-drawer', 'dw-mobile-drawer--left');
      homeNav.setAttribute('data-dw-drawer-panel', 'home-nav');
      /* Desktop: in-column nav is visible; mobile: hidden until drawer opens. */
      homeNav.setAttribute(
        'aria-hidden',
        window.innerWidth > panelMobileMax('home-nav') ? 'false' : 'true'
      );
    }
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-dw-drawer-open]');
      if (openBtn) {
        e.preventDefault();
        open(openBtn.getAttribute('data-dw-drawer-open'), openBtn);
        return;
      }

      if (e.target.closest('.btn-menu-canvas')) {
        e.preventDefault();
        open('menu', e.target.closest('.btn-menu-canvas'));
        return;
      }

      if (e.target.closest('a.dw-header-cart-toggle, .cartToggle')) {
        e.preventDefault();
        open('cart', e.target.closest('a.dw-header-cart-toggle, .cartToggle'));
        return;
      }

      if (e.target.closest('.filter-collection-left > a')) {
        var link = e.target.closest('.filter-collection-left > a');
        var target = link.getAttribute('data-dw-drawer-open') || 'filters';
        if (window.innerWidth <= panelMobileMax(target)) {
          e.preventDefault();
          open(target, link);
        }
        return;
      }

      if (e.target.closest('.continue-shoping a, #off-canvas-button, .close12, [data-dw-drawer-close]')) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target.closest('.dw-drawer-overlay.is-visible')) {
        close();
      }
    });

    document.addEventListener('mouseup', function (e) {
      if (activeId === 'menu') {
        var menu = getPanelEl('menu');
        if (!menu || !menu.classList.contains('active')) return;
        if (menu.contains(e.target)) return;
        if (e.target.closest('.btn-menu-canvas')) return;
        close();
        return;
      }
      if (activeId === 'cart') {
        var cart = getPanelEl('cart');
        if (!cart || !cart.classList.contains('active')) return;
        if (cart.contains(e.target)) return;
        if (e.target.closest('a.dw-header-cart-toggle, .cartToggle')) return;
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeId) {
        e.preventDefault();
        close();
        return;
      }
      var filterLink = e.target.closest('.filter-collection-left > a');
      if (filterLink && (e.key === 'Enter' || e.key === ' ')) {
        var target = filterLink.getAttribute('data-dw-drawer-open') || 'filters';
        if (window.innerWidth <= panelMobileMax(target)) {
          e.preventDefault();
          open(target, filterLink);
        }
      }
    });

    document.addEventListener('submit', function (e) {
      if (activeId !== 'filters') return;
      if (e.target.matches('.dw-storefront-filters-form') || e.target.closest('.dw-storefront-filters-form')) {
        close();
      }
    });

    window.addEventListener('resize', function () {
      if (activeId && panels[activeId].mobileOnly && window.innerWidth > panelMobileMax(activeId)) {
        close();
      }
      var homeNav = document.getElementById('dw-home-sidebar');
      if (homeNav && activeId !== 'home-nav') {
        homeNav.setAttribute(
          'aria-hidden',
          window.innerWidth > panelMobileMax('home-nav') ? 'false' : 'true'
        );
      }
    });
  }

  window.DwMobileDrawer = {
    open: open,
    close: close,
    closeAll: closeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMarkup();
      bindEvents();
    });
  } else {
    initMarkup();
    bindEvents();
  }
})();
